export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5149.933f79a7.jpg";